module.exports = __webpack_public_path__ + "img/stock4.6106ee74.png";